import React from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

interface IDataCompareBarProps {
  leftValue: number;
  rightValue: number;
  leftLabel: string;
  rightLabel: string;
  label: string;
  defaultPecentage?: number; // 0-100
}

interface IBarStyleProps {
  leftWidth: number;
  leftValue: number;
  rightWidth: number;
  rightValue: number;
}

const HEIGHT = 16;
const BORDER_RADIUS = 5;
const WINNER_COLOR = "#B4DC73";
const LOSER_COLOR = "#FF867C";

const useStyles = makeStyles((theme) => ({
  leftBar: ({ leftWidth, leftValue, rightValue }: IBarStyleProps) => ({
    height: HEIGHT,
    backgroundColor: leftValue >= rightValue ? WINNER_COLOR : LOSER_COLOR,
    borderRadius: BORDER_RADIUS,
    width: `${leftWidth}%`,
  }),
  rightBar: ({ rightWidth, leftValue, rightValue }: IBarStyleProps) => ({
    height: HEIGHT,
    backgroundColor: leftValue >= rightValue ? LOSER_COLOR : WINNER_COLOR,
    borderRadius: BORDER_RADIUS,
    width: `${rightWidth}%`,
  }),
}));

export const DataCompareBar = ({
  leftValue,
  leftLabel,
  rightValue,
  rightLabel,
  label,
  defaultPecentage = 75,
}: IDataCompareBarProps) => {
  let leftPecentage, rightPecentage;
  if (leftValue === 0 && rightValue === 0) {
    leftPecentage = 0;
    rightPecentage = 0;
  } else if (leftValue === 0 || rightValue === 0) {
    leftPecentage = leftValue ? defaultPecentage : 0;
    rightPecentage = rightValue ? defaultPecentage : 0;
  } else {
    const total = leftValue + rightValue;
    leftPecentage = (leftValue / total) * 100;
    rightPecentage = (rightValue / total) * 100;
  }

  const classes = useStyles({
    leftWidth: leftPecentage,
    leftValue: leftValue,
    rightWidth: rightPecentage,
    rightValue: rightValue,
  });

  return (
    <Grid container>
      <Grid item xs={4}>
        <Box display="flex" justifyContent="flex-end">
          <div className={classes.leftBar} />
        </Box>
      </Grid>
      <Grid item xs={1}>
        <Typography align="center">{leftLabel}</Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="h3" align="center">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography align="center">{rightLabel}</Typography>
      </Grid>
      <Grid item xs={4}>
        <div className={classes.rightBar} />
      </Grid>
    </Grid>
  );
};
